export const pluralise = (count, singular, plural) => (
  (count === 0 ? 'No' : count) + 
  ' ' +
  (count === 1 ? singular : (plural || `${singular}s`))
)


export const lastWord = (phrase) => {
  const words = String(phrase).split(' ')

  return words[words.length - 1]
}

export const titleise = (word) => {
  const letter = word[0]
  return letter ?
    word.replace(letter, letter.toUpperCase()) :
    word
}



// WEBPACK FOOTER //
// ./src/text-transformations/index.js